import { darken, mode, whiten } from '@chakra-ui/theme-tools';

const buttonStyle = {
  // style object for base or default style
  baseStyle: {
    color: 'white',
  },
  // styles for different sizes ("sm", "md", "lg")
  // sizes: {
  //   sm: {},
  //   md: {},
  //   lg: {},
  // },
  // styles for different visual variants ("outline", "solid")
  variants: {
    primary: (props) => ({
      bg: 'brand.primary',
      _hover: {
        bg: mode(
          darken('brand.primary', 10),
          whiten('brand.primary', 10)
        )(props),
      },
    }),
    success: (props) => ({
      bg: 'green.500',
      _hover: {
        bg: mode(darken('green.500', 10), whiten('green.500', 10))(props),
      },
    }),
    outline: {
      border: '2px solid',
      borderColor: 'brand.primary',
      color: 'brand.primary',
      _hover: {
        backgroundColor: 'brand.primary',
        color: 'white',
      },
    },
  },
  // default values for `size` and `variant`
  defaultProps: {
    size: 'md',
    variant: 'primary',
  },
};

export { buttonStyle };
